<ng-container *ngIf="showBanner">
  <button type="button" class="available-banner" [class.has-suggestions]="availableCount > 0" [attr.aria-pressed]="expanded" (click)="toggle()">
    <i class="fas fa-lightbulb"></i>
    <span>{{ expanded ? 'Availability Mode · Back to Manual Adjust' : 'ORION Adjustments Available' }}</span>
    <span class="count" *ngIf="availableCount > 0">{{ availableCount }}</span>
  </button>
</ng-container>
<div *ngIf="expanded" class="available-cards">
  <div class="availability-error" *ngIf="error">{{ error }} <button type="button" (click)="refresh()">Retry</button></div>
  <div class="availability-note" *ngIf="!visibleCards.length && loading">Loading Available Adjustments…</div>
  <div class="availability-note" *ngIf="!visibleCards.length && !error && !loading">No Adjustments Available.</div>
  <div class="availability-note" *ngFor="let card of hiddenPreviews; trackBy: trackCard">
    Active Preview · {{ card.proposal.hedgeLabel }}
    <dx-button text="Un-Preview" stylingMode="outlined" (onClick)="preview(card)" [disabled]="card.busy || card.solution.state.applied"></dx-button>
  </div>
  <div *ngFor="let card of visibleCards; trackBy: trackCard">
    <div class="availability-note" *ngIf="card.message">{{ card.message }}</div>
    <ets-hg-copilot-solution-card [solution]="card.solution" [ctx]="ctx" [heldAtRun]="card.held"
      [proposalSnapshot]="card.proposal" [placementBlocked]="card.busy || !card.currentlyAvailable"
      [displayReference]="displayReference(card)"
      (proposalDisplayed)="inspected($event)" (previewToggle)="preview(card)" (applyToggle)="apply(card)">
    </ets-hg-copilot-solution-card>
  </div>
</div>
